import { Splash } from '@salecycle/ui-component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAccessLevel } from 'core/app/AppContext';

export const SearchOverlayWelcome: React.FC = () => {
  const { t } = useTranslation();
  const { accessLevel } = useAccessLevel();

  return (
    <Splash
      imageUrl="/images/search-welcome-splash.png"
      heading={t('client.search.welcome.heading', {
        context: accessLevel === 'MultiSite' ? 'multisite' : null,
      })}
      description={t('client.search.welcome.description', {
        context: accessLevel === 'MultiSite' ? 'multisite' : null,
      })}
    />
  );
};
